import { LoginResponse, MemberTypes } from '../models/ss-api/responses/login.response';
import { Injectable } from '@angular/core';
import { ssApiService } from 'app/services/ss-api.service';
import { DashboardProductsResponse } from 'app/models/ss-api/responses/dashboard.products.response';
import { environment } from 'environments/environment';
import { Title, Meta } from '@angular/platform-browser';
import { MemberBasicInfoResponse } from 'app/models/ss-api/responses/member.basic.info.response';
import { TrainingHistoryComponent } from 'app/account/components/training-history/training-history.component';
import { Subject } from 'rxjs';
import { IBaseResponse } from 'app/models/comm-http/responses/BaseResponse';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable()
export class GlobalServices {

    HttpTimeout: number = 20000;

    AdminID: number = 0;
    MemberID: number;
    Username: string;
    FirstName: string;
    LastName: string;
    Email: string;
    MemberType: MemberTypes;

    Token: string;
    TokenExpiration: Date;
    DateTimeLogin: Date;

    ServerDateTime: Date;

    MyProducts: DashboardProductsResponse;

	public MemberBasicInfo: MemberBasicInfoResponse = new MemberBasicInfoResponse();

	public hasValidAddress : boolean = false;

    // OrderFormVersion
    OrderFormVersion : string = 'v1-3'
    // When Updated you MUST update the report panel with a new order form tempalte for JPEG screenshots as well!!!

    
    // Dev variables from environment settings
    envName: string = environment.envName;
    isDevMode: boolean = false;
    ReportURL: string = environment.reportUrl;

	public onMemberProfileUpdated = new Subject<IBaseResponse<MemberBasicInfoResponse>>();

    constructor(private api: ssApiService, private titleService: Title, private meta : Meta, private router: Router ) {
        this.ReadFromStorage();
        this.SubscribeEvents();

        this.ReportURL = this.api.GetReportBotURL();
        this.isDevMode = this.api.isDev;

        this.meta.addTag({ name: 'description', content : 'Structure Studios Member site for managing accounts.' });

        console.log(router.url);
        if (!router.url.toLowerCase().startsWith("/order-form"))
        {
            this.GetMemberInfo();
        }		

    }

    public SetGlobalsFromLoginResponse(data: LoginResponse, skipToken: boolean = false) {

        this.MemberID = data.MemberID;
        this.DateTimeLogin = new Date();

        this.ServerDateTime = new Date();

        this.Email = data.Email;
        this.Username = data.Username;
        this.FirstName = data.FirstName;
        this.LastName = data.LastName;
        this.Token = data.Token;
        this.TokenExpiration = data.TokenExpiration;
        this.MemberType = data.MemberType;

        localStorage.setItem('MemberID', data.MemberID.toString());
        localStorage.setItem('DateTimeLogin', new Date().toString());
        localStorage.setItem('Email', data.Email);
        localStorage.setItem('Username', data.Username);
        localStorage.setItem('FirstName', data.FirstName);
        localStorage.setItem('LastName', data.LastName);
        localStorage.setItem('MemberType', data.MemberType.toString());

        localStorage.setItem('email', data.Username);
        localStorage.setItem('token_expiration', data.TokenExpiration.toString());

        // skip token?
        // we skip token when we come from login as member from admin
        if (!skipToken)
            localStorage.setItem('token', data.Token);
        
        if (!this.router.url.toLowerCase().startsWith("/order-form")) {
            this.GetMemberInfo();
        }
    }

    public Logout() {
        localStorage.clear();
  }

  public IsDevPublic(): boolean {

    var url = window.location.hostname;
    return url.toLowerCase().includes("members-dev.structurestudios.com")

  }

  public IsLocal(): boolean {

    var url = window.location.hostname;
    return url.toLowerCase().includes("localhost");

  }

	
	public gettingAddress : boolean = false;

	public GetMemberInfo() {
		this.gettingAddress = true;

		let disposable = this.api.MemberBasicInfo().subscribe(response => {
			disposable.unsubscribe();

			if (!response.Result)
				return; // error

			this.MemberBasicInfo = response.Data;
			
			let hasAddress = true;

			if( this.MemberBasicInfo.Address1 == "" || this.MemberBasicInfo.Address1 == undefined )
				hasAddress = false;
			else if( this.MemberBasicInfo.City == "" || this.MemberBasicInfo.City == undefined )
				hasAddress = false;
			else if( this.MemberBasicInfo.State == "" || this.MemberBasicInfo.State == undefined )
				hasAddress = false;
			else if( this.MemberBasicInfo.ZipCode == "" || this.MemberBasicInfo.ZipCode == undefined )
				hasAddress = false;

			this.hasValidAddress = hasAddress;
			this.gettingAddress = false;

			console.log("GetMemberInfo() complete");
			console.log(response);

			this.onMemberProfileUpdated.next( response );

		}, error => {
			disposable.unsubscribe();
			this.hasValidAddress = false;
			this.gettingAddress = false;
			console.log("GetMemberInfo() ERROR");

		});
	}

	
	public CheckMemberInfo() {
		console.log("checking member info", this.MemberBasicInfo);
		this.GetMemberInfo();
		
	}
	

    public SetPageTitle( title : string, description : string = "" ) {
        
        this.titleService.setTitle(title + " | Member Panel | StructureStudios.com");

        if( description == "" )
            description = "Structure Studios Member site for managing accounts.";

        this.meta.updateTag({ name: 'description', content: description });

    }

    public SetToken(token: string) {
        this.Token = token;
        localStorage.setItem('token', token);
    }

    SubscribeEvents() {
        this.api.onProductsMyProducts.subscribe((response) => { this.MyProducts = response.Data; });
    }

    public static replaceAll(str, find, replace) {
        return str.replace(new RegExp(this.escapeRegExp(find), 'g'), replace);
    }

    public static escapeRegExp(str) {
        return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1');
    }

    TokenToUrlFriendly(): string {
        return GlobalServices.ConverToUrlFriendly(this.Token);
    }

    public static ConverToUrlFriendly(input: string): string {
        // this.Token = this.Token.Replace("\\", "_");
        input = this.replaceAll(input, '/', '~');
        input = this.replaceAll(input, '+', '|');
        input = this.replaceAll(input, '=', '<');

        return input;
    }

    public static ConverFromUrlFriendly(input: string): string {
        // this.Token = this.Token.Replace("\\", "_");
        input = this.replaceAll(input, '~', '/');
        input = this.replaceAll(input, '|', '+');
        input = this.replaceAll(input, '<', '=');

        return input;
    }

    public ClearOrderFormLocalStorage() {
        localStorage.removeItem('cartProductID');
        localStorage.removeItem('cartBillingCycle');
        localStorage.removeItem('cartHasYard');
        localStorage.removeItem('email');
    }

    ReadFromStorage() {

        let MemberID = localStorage.getItem('MemberID');
        if (MemberID != undefined)
            this.MemberID = <any>MemberID;

        let Username = localStorage.getItem('Username');
        if (Username != undefined)
            this.Username = Username;

        let FirstName = localStorage.getItem('FirstName');
        if (FirstName != undefined)
            this.FirstName = FirstName;

        let LastName = localStorage.getItem('LastName');
        if (LastName != undefined)
            this.LastName = LastName;

        let Email = localStorage.getItem('email');
        if (Email != undefined)
            this.Email = Email;

        let MemberType: number = <any>localStorage.getItem('MemberType');
        if (MemberType != undefined)
            this.MemberType = MemberType;

        let Token = localStorage.getItem('token');
        if (Token != undefined)
            this.Token = Token;

        let TokenExpiration = localStorage.getItem('token_expiration');
        if (TokenExpiration != undefined)
            this.TokenExpiration = new Date(TokenExpiration);

        let DateTimeLogin = localStorage.getItem('DateTimeLogin');
        if (DateTimeLogin != undefined)
            this.DateTimeLogin = new Date(DateTimeLogin);

	}
	


	public FormattedPhone( v : string ) : string {
		
		if( v == null || v == undefined ) {
			return '';
		}

		// trim '-' dashes
		v = v.replace(/-/g,'');

		v = v.replace(/[^\d]/g, "");
		
		// trim string to 15 characters
		if( v.length > 10) {
			if (v.length > 15) {
				v = v.substr(0, 15);
			}
			return '   +' + v;
		}
		

    // new array to hold sections of the License Key
		let numbers = [];

		// create set of characters from first 5 characters
		numbers.push(v.substr(0,3));
		
		// try for next 5
		if(v.substr(3,3)!=="")
			numbers.push(v.substr(3,3));
		
		// and last set of 5
		if(v.substr(6,10)!="")
			numbers.push(v.substr(6,4));
		
		if(v.substr(10,15)!="")
			numbers.push(v.substr(10,5));

		// add '-' dashes back to formated string
		let newValue = numbers[0];
		
		//if( newValue.length == 3 ) {
			
		//}

		if( numbers.length > 1 ) {
			newValue = '(' + newValue + ') ';
			newValue += numbers[1];
		}
			

		if (numbers.length > 2 )
			newValue += '-' + numbers[2];

		// if (numbers.length > 3 )
		// 	newValue += '-' + numbers[3];

		return newValue;
	}

    ThisMonth() {
        const month = new Date().getMonth() + 1;

        if (month < 10) {
            return '0' + month;
        } else {
            return month;
        }
    }
	

}
